module.exports = __webpack_public_path__ + "static/img/genre_05.8a5bc04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/genre_05.png
// module id = GVYc
// module chunks = 0